/* @jsxImportSource @emotion/react */

import { useIntl } from 'react-intl'

import { ArrowRightIcon, CrossIcon } from '@slite/icons'

import { SMALL_BREAKPOINT } from '../utils/breakpoints'

export const BANNER_HEIGHT = 28

type BannerProps = {
  title: string
  description?: string
  link: string
  linkLabel: string
  onDismiss: () => void
}

export const Banner = ({
  title,
  description,
  link,
  linkLabel,
  onDismiss,
}: BannerProps) => {
  const intl = useIntl()
  return (
    <div
      className="shade-00"
      css={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1001,
        height: `${BANNER_HEIGHT}px`,
        backgroundColor: 'var(--saturn-orange)',
      }}
    >
      <a
        href={link}
        className="flexbox flexbox-align-center flexbox-justify-center shade-100 transition height-full"
        css={{
          fontSize: 13,
          gap: 12,
          textDecoration: 'none',
          whiteSpace: 'nowrap',
          ':hover .banner-cta-arrow': { transform: 'translateX(3px)' },
          [`@media (max-width: ${SMALL_BREAKPOINT - 1}px)`]: {
            gap: 8,
            fontSize: 12,
          },
        }}
      >
        <span className="font-weight-bold">{title}</span>
        {description && (
          <span
            className="opacity-large"
            css={{
              [`@media (max-width: ${SMALL_BREAKPOINT - 1}px)`]: {
                display: 'none',
              },
            }}
          >
            {description}
          </span>
        )}
        <span
          className="flexbox flexbox-align-center font-weight-bold"
          css={{ gap: 4, paddingLeft: 24 }}
        >
          {linkLabel}
          <ArrowRightIcon
            size={12}
            className="banner-cta-arrow"
            css={{ transition: 'transform 0.2s ease' }}
          />
        </span>
      </a>
      <button
        type="button"
        onClick={onDismiss}
        aria-label={intl.formatMessage({
          id: 'banner.dismiss',
          defaultMessage: 'Dismiss banner',
        })}
        className="position-absolute height-full border-none background-transparent shade-100 transition pointer flexbox flexbox-centered"
        css={{ top: 0, right: 0, width: BANNER_HEIGHT }}
      >
        <CrossIcon size={14} />
      </button>
    </div>
  )
}
